import { SelectEditor } from './selectEditor';
export class SingleSelectEditor extends SelectEditor {
    /**
     * Initialize the Editor
     */
    constructor(args) {
        super(args, false);
        this.args = args;
    }
}
//# sourceMappingURL=singleSelectEditor.js.map